Controller = App.loadClass 'core::Angular/Controller'

class exports.LocationController extends Controller
    constructor: (@scope, @transitions, @state, @location) ->
        @scope.repo = @location
        @geocoder = App.load 'core::Geocoder'

        $('.leaflet-control-container').show()
        $('.leaflet-control-buttongrid').hide()


        @scope.transitionTo = (state_name) =>
            @state.go state_name


        @scope.search = () =>
            @geocoder.geocode(@location.new.address)


        # Transition Hooks
        @transitionStart = @transitions.onStart {}, ($transition) =>
            if $transition.to().name isnt 'grower.buyerlocation.place'
                App.map.removeLayer(@location.feature_group) if @location.feature_group?
                setTimeout () =>
                    App.map.removeControl(@location.drawControl)
                , 100
                # # show the drawing controls container since we're leaving the process
                # $('.leaflet-control-container').show()
            # else
            #     # only hide the toolbar if we are going to the step before or after this one
            #     $('.leaflet-control-container').hide()


        @scope.$on '$destroy', () =>
            @transitionStart()

